import { useQuery } from '@tanstack/react-query';
import { getJobById } from '../Services/JobServices';

export const useJobById = (id, enabled = true) =>
    useQuery({
        queryKey: ['Job', id],
        queryFn: () => getJobById(id),
        enabled: !!id && enabled, // don't run unless id is valid
        staleTime: 5 * 60 * 1000, // 5 minutes: data is "fresh"
        cacheTime: 5 * 60 * 1000, // 5 minutes: data stays in cache
    });
